var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecapLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 72",
    style: {
      enableBackground: "new 0 0 250 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.fill-pink{fill:#FF0082;}\n\t.fill-white{fill:#000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill-pink",
    d: "M24.2,2.9L1.7,5l2.7,29.5l14.7-1.3l-1.5-16l7.8-0.7c7.8-0.7,14,5.5,14.9,14.8c0,0,0,0,0,0l14.4-1.3 C53.3,13.6,39.6,1.5,24.2,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-pink",
    d: "M55.7,39.1c0,9.3-5.7,16.1-13.5,16.1h-7.9V39.1H19.6v29.6h22.6c15.4,0,27.9-13.3,27.9-29.6c0,0,0,0,0,0 L55.7,39.1C55.7,39.1,55.7,39.1,55.7,39.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M98.2,20.2h14.7c10.6,0,17.8,6.7,17.8,16.9S123.4,54,112.8,54H98.2V20.2z M112.5,47.5c6.4,0,10.6-4,10.6-10.5 c0-6.5-4.2-10.5-10.6-10.5h-6.8v20.9H112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M153.8,45.8l3.8,4.3c-2.3,2.8-5.8,4.2-10.2,4.2c-8.6,0-14.2-5.6-14.2-13.4c0-7.8,5.6-13.4,13.3-13.4 c7,0,12.8,4.8,12.8,13.1L141,44.5c1.1,2.6,3.4,3.9,6.6,3.9C150.2,48.3,152.1,47.5,153.8,45.8z M140.3,40.2l12.1-2.5 c-0.7-2.7-2.9-4.4-5.9-4.4C142.9,33.3,140.4,35.8,140.3,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M161.6,41c0-7.8,5.8-13.4,13.8-13.4c5.2,0,9.3,2.4,11.1,6.6l-5.6,3.1c-1.3-2.5-3.3-3.6-5.6-3.6c-3.6,0-6.5,2.7-6.5,7.2 s2.9,7.2,6.5,7.2c2.3,0,4.2-1.1,5.6-3.6l5.6,3.2c-1.8,4.2-5.9,6.6-11.1,6.6C167.4,54.3,161.6,48.8,161.6,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M214.9,28v26H208v-3c-1.8,2.3-4.4,3.4-7.7,3.4c-7,0-12.4-5.2-12.4-13.4s5.4-13.4,12.4-13.4c3,0,5.6,1,7.4,3.1V28H214.9z  M207.8,41c0-4.5-2.8-7.2-6.3-7.2c-3.6,0-6.4,2.7-6.4,7.2s2.8,7.2,6.4,7.2C205.1,48.2,207.8,45.5,207.8,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    d: "M247.9,41c0,8.2-5.4,13.4-12.4,13.4c-3.1,0-5.6-1-7.5-3.1v12.1h-7.2V28h6.9v3c1.8-2.3,4.5-3.4,7.8-3.4 C242.5,27.6,247.9,32.8,247.9,41z M240.6,41c0-4.5-2.7-7.2-6.3-7.2s-6.3,2.7-6.3,7.2s2.7,7.2,6.3,7.2S240.6,45.5,240.6,41z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecapLogo);
export default __webpack_public_path__ + "static/media/decap-logo.75142a4989db587dde25ac2cd41889b8.svg";
export { ForwardRef as ReactComponent };